module.exports = __webpack_public_path__ + "static/images/styles/images/building-card/building-card-bg-100.2cc8db88.jpg";


//////////////////
// WEBPACK FOOTER
// ./styles/images/building-card/building-card-bg-100.jpg
// module id = 3493
// module chunks = 11